import React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useApis } from '../../api/useApiClient';
import { useTenant } from '../../context/TenantContext';
import { useNotification } from "../../context/NotificationContext";

import {
    Card,
    CardContent,
    Typography,
    Button,
    Grid,
    Box,
} from "@mui/material";


import AppLoadingView from '../Common/AppLoadingView';
import LoadingViewIcon from '@mui/icons-material/Person';

const SelectTenant = () => {
    const { selectTenant } = useTenant();
    const { showNotification } = useNotification();
    const { authApi, tenantApi } = useApis();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({});

    const getData = async () => {
        try {
            setLoading(true);
            const res = await authApi("/me");
            setData(res?.data);
        } catch (e) {
            console.error(e);
            showNotification(
                e.message || "Failed to load tenants",
                "error"
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getData();
    }, []);


    function setTenant(membership) {
        console.log("Setting tenant to ", membership);
        selectTenant({
            id: membership.tenant.id,
            name: membership.tenant.name,
            domain: membership.tenant.domain,
            role: membership.role.name,
        });

        // When switching tenants, always land on the new tenant home.
        navigate('/', { replace: true });
    }

    if (loading) {
        return <AppLoadingView 
            title="Loading your profile" 
            description="Please wait while we fetch your profile information and access permissions."
            icon={LoadingViewIcon}
        />;
    }

    else if (!data || !data.memberships || data.memberships.length === 0) {
        return (
            <Box
                sx={{
                    maxWidth: 600,
                    mx: "auto",
                    p: 4,
                    textAlign: "center",
                }}
            >
                <Typography variant="h5" align="center" gutterBottom>
                    No Organizations Found
                </Typography>
                <Typography
                    variant="body2"
                    align="center"
                    color="text.secondary"
                    sx={{ mb: 4 }}
                >
                    You are not a member of any organizations. Please contact your administrator.
                </Typography>
            </Box>
        );
    }

    else {

        return (
            <Box
                sx={{
                    maxWidth: 600,
                    mx: "auto",
                    p: 4,
                }}
            >
                <Typography variant="h5" align="center" gutterBottom>
                    Welcome, {data.name}
                </Typography>
                <Typography
                    variant="body2"
                    align="center"
                    color="text.secondary"
                    sx={{ mb: 4 }}
                >
                    Please select which organization you want to continue with
                </Typography>

                <Grid container spacing={2}>
                    {data.memberships.map((membership) => (
                        <Grid item xs={12} key={membership.id}>
                            <Card
                                variant="outlined"
                                sx={{
                                    cursor: "pointer",
                                    "&:hover": { boxShadow: 3, borderColor: "primary.main" },
                                }}
                                onClick={() => setTenant(membership)}
                            >
                                <CardContent
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        p: 3,
                                    }}
                                >
                                    <Box>
                                        <Typography variant="h6">
                                            {membership.tenant.name}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {membership.tenant.domain}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                            Role: {membership.role.name}
                                        </Typography>
                                    </Box>
                                    <Button
                                        variant="outlined"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setTenant(membership);
                                        }}
                                    >
                                        Continue
                                    </Button>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        );
    }
};

export default SelectTenant;